export default {
  subjectDirectoryDetail: {
    component: () =>
      import(
        /* webpackChunkName: "transfer_detail" */ "@/mods/archive/topicLibrary/detailView/SubjectDirectoryDetail"
      ),
  },
};
